// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateEpmMasterVddMutationVariables = Types.Exact<{
  input: Types.CreateEpmMasterVddInput;
}>;

export type CreateEpmMasterVddMutation = { __typename?: 'Mutation' } & {
  createEpmMasterVdd: { __typename?: 'EpmMasterVddOutput' } & Pick<Types.EpmMasterVddOutput, 'id'>;
};

export const CreateEpmMasterVddDocument = /*#__PURE__*/ gql`
    mutation createEpmMasterVdd($input: CreateEpmMasterVddInput!) {
  createEpmMasterVdd(input: $input) {
    id
  }
}
    `;
export type CreateEpmMasterVddMutationFn = Apollo.MutationFunction<
  CreateEpmMasterVddMutation,
  CreateEpmMasterVddMutationVariables
>;

/**
 * __useCreateEpmMasterVddMutation__
 *
 * To run a mutation, you first call `useCreateEpmMasterVddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpmMasterVddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpmMasterVddMutation, { data, loading, error }] = useCreateEpmMasterVddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEpmMasterVddMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEpmMasterVddMutation, CreateEpmMasterVddMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEpmMasterVddMutation, CreateEpmMasterVddMutationVariables>(
    CreateEpmMasterVddDocument,
    options,
  );
}
export type CreateEpmMasterVddMutationHookResult = ReturnType<typeof useCreateEpmMasterVddMutation>;
export type CreateEpmMasterVddMutationOptions = Apollo.BaseMutationOptions<
  CreateEpmMasterVddMutation,
  CreateEpmMasterVddMutationVariables
>;
